export const messages = {
  en: {
    communityWechat: {
      page: {
        title: 'Community WeChat',
        subtitle: 'Manage the official WeChat account bound to each community',
        empty: 'No WeChat account records',
        loadFailed: 'Failed to load WeChat account list, please retry',
        tip: 'The app secret is masked and cannot be viewed here; modify it in the WeChat official platform if needed',
        currentCommunityTip: 'Only the WeChat accounts of the currently selected community are shown'
      },
      search: {
        name: 'Please enter the exact WeChat account name'
      },
      communityList: 'Community List',
      title: 'WeChat Account List',
      name: 'Name',
      communityName: 'Community Name',
      appId: 'APPID',
      appSecret: 'App Secret',
      description: 'Description',
      operation: 'Operation',
      add: 'Add',
      edit: 'Edit',
      cancel: 'Cancel',
      save: 'Save',
      required: 'Required',
      maxLength100: 'Cannot exceed 100 characters',
      maxLength200: 'Cannot exceed 200 characters',
      addSuccess: 'Add successful',
      editSuccess: 'Update successful',
      loadFailed: 'Failed to load WeChat account list, please retry'
    },
    addCommunityWechat: {
      title: 'Add WeChat',
      name: 'Name',
      appId: 'APPID',
      appSecret: 'App Secret',
      description: 'Description',
      remarks: 'Remarks',
      placeholder: {
        name: 'Required, please enter name',
        appId: 'Required, please enter APPID',
        appSecret: 'Required, please enter app secret',
        remarks: 'Optional, please enter description'
      }
    },
    editCommunityWechat: {
      title: 'Edit WeChat',
      name: 'Name',
      appId: 'APPID',
      appSecret: 'App Secret',
      description: 'Description',
      remarks: 'Remarks',
      placeholder: {
        name: 'Required, please enter name',
        appId: 'Required, please enter APPID',
        appSecret: 'Required, please enter app secret',
        remarks: 'Optional, please enter description'
      }
    },
  },
  zh: {
    communityWechat: {
      page: {
        title: '小区公众号',
        subtitle: '维护各小区绑定的微信公众号配置',
        empty: '暂无公众号记录',
        loadFailed: '公众号列表加载失败，请重试',
        tip: '应用密钥已脱敏处理，如需变更请前往微信公众平台操作',
        currentCommunityTip: '仅展示当前所选小区下的公众号'
      },
      search: {
        name: '请输入公众号名称（精确匹配）'
      },
      communityList: '小区列表',
      title: '公众号列表',
      name: '名称',
      communityName: '小区名称',
      appId: 'APPID',
      appSecret: '应用密钥',
      description: '描述',
      operation: '操作',
      add: '添加',
      edit: '修改',
      cancel: '取消',
      save: '保存',
      required: '不能为空',
      maxLength100: '不能超过100个字符',
      maxLength200: '不能超过200个字符',
      addSuccess: '添加成功',
      editSuccess: '修改成功',
      loadFailed: '公众号列表加载失败，请重试'
    },
    addCommunityWechat: {
      title: '添加',
      name: '名称',
      appId: 'APPID',
      appSecret: '应用密钥',
      description: '描述',
      remarks: '备注',
      placeholder: {
        name: '必填，请填写名称',
        appId: '必填，请填写APPID',
        appSecret: '必填，请填写应用密钥',
        remarks: '选填，请填写描述信息'
      }
    },
    editCommunityWechat: {
      title: '修改公众号',
      name: '名称',
      appId: 'APPID',
      appSecret: '应用密钥',
      description: '描述',
      remarks: '备注',
      placeholder: {
        name: '必填，请填写名称',
        appId: '必填，请填写APPID',
        appSecret: '必填，请填写应用密钥',
        remarks: '选填，请填写描述信息'
      }
    },
  }
}
